import { render, staticRenderFns } from "./EcommpayDepositLoader.vue?vue&type=template&id=2ba8fc1a&scoped=true"
import script from "./EcommpayDepositLoader.vue?vue&type=script&lang=js"
export * from "./EcommpayDepositLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8fc1a",
  null
  
)

export default component.exports